import MainLayout from "../layout/MainLayout";
import img1 from '../assets/images/page1-1.png'
import img3 from '../assets/images/page1-2.png'
import img4 from '../assets/images/page1-3.png'
import img5 from '../assets/images/page1-4.png'
import img6 from '../assets/images/page3-2.png'
import img7 from '../assets/images/img-8.png'
import { Link } from "react-router-dom";

const Home = () => {

    const data = [
        { image: img1, title: "QR CODE Penghuni", link: "/scanner" }, 
        { image: img7, title: "PROMISE TO PAY", link: "/promise-to-pay" },
        { image: img6, title: "LAPORAN KUTIPAN BAYARAN", link: "/payment-report" }, 
        { image: img4, title: "LAPORAN TUNGGAKAN ", link: "/tunggakan" }, 
        { image: img5, title: "AKAUN PERIBADI KAKITANGAN", link: "/staff-detail" },

        { image: img3, title: "Unit Rampas / Kosong / Tamat Kontrak", link: "#" },
    ]


    return (
        <MainLayout>
            {/* <div className="p-5">
                {/* <Link to="/scanner">
            <div className="flex flex-col items-left justify-center ">
                    <img src={img1} className="w-12 lg:w-10" alt="" />
                    <h3 className=" text-gray-500 text-sm  font-bold uppercase">QR CODE <br/> Penghuni</h3>
            </div>
                </Link> */}
            {/* <div className="flex flex-wrap justify-around gap-4 mt-4">
                
                {data.map((item, index) => (
                    <div key={index} className="w-1/4  flex ">
                        <Link to={item.link}> 
                        <div className="flex flex-col text-center items-center  ">
                            <img src={item.image} className="w-12 lg:w-8 " alt="" />
                            <h3 className=" text-gray-500 text-sm  font-bold">{item.title}</h3>
                        </div>
                        </Link>
                    </div>
                ))}
            </div>
            </div>  */}

            <div className="p-5">
  <div className="flex flex-col gap-3 mt-4">
    {data.map((item, index) => (
      <Link key={index} to={item.link} className="w-full">
        <div className="flex items-center justify-start gap-3">
          <img src={item.image} className="w-12 lg:w-8" alt="" />
          <h3 className="text-gray-500 text-sm font-bold">{item.title.toUpperCase()}</h3>
        </div>
      </Link>
    ))}
  </div>
</div>


        </MainLayout>
    );
}
export default Home;